(function() {
    /**
     * Defines all globally defined custom events. Used with $broadcast and $on to communicate between controllers, services, ...
     */
    angular.module("app").constant("HABIL_EVENTS", {
        navigation: {
            tabChanged: "navigation_change",
            goToTab: "go_to_tab",
            nextTab: "actionBar_nextClick",
            previousTab: "actionBar_previousClick",
            goToNextInvalidatedTab: "validation_GoToNextInvalidatedTab"
        },
        actionBar: {
            save: "actionBar_saveClick",
            close: "actionBar_closeClick",
            isAllowed: "request_stateChangedTo",
            canSave: "request_stateCanSave"
        }
    });
})();